export default __webpack_public_path__ + "static/media/no_image.9aba454c.png";